export const XEmperorSvg = ({ width }: { width: number }) => {
  return (
    <svg
      width={width}
      height={(width / 78) * 84}
      viewBox="0 0 78 84"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M61.5 55.5C82 33.2174 66 0.50002 39 0.500061C6.66449 0.50011 -0.500001 40 15 55C16.5138 56.465 18 57.5001 19 56.5C20 55.5 19.7747 54.2748 18.5 53C9 43.5 10.5 7.00006 39 7.00006C67.4999 7.00006 68.5 41.5 59.5 53C58.389 54.4197 57.0999 55.5 58.5 56.5C59.9 57.5001 60.2283 56.8823 61.5 55.5Z"
        fill="#FEFEFE"
        stroke="black"
      />
      <path
        d="M37.5 30H1L2.5 34.5C11.5 36 26.3 37.5 29.5 39.5C32.7 41.5 32.8333 67.6667 32.5 80.5C33.5 82.5 34.3 83 35.5 83C36.7 83 37.6667 81.3333 38 80.5L37.5 30Z"
        fill="#FEFEFE"
        stroke="black"
      />
      <path
        d="M40.5 30H77L75.5 34.5C66.5 36 51.7 37.5 48.5 39.5C45.3 41.5 45.1667 67.6667 45.5 80.5C44.5 82.5 43.7 83 42.5 83C41.3 83 40.3333 81.3333 40 80.5L40.5 30Z"
        fill="#FEFEFE"
        stroke="black"
      />
    </svg>
  );
};
